import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from 'react-router-dom';

import { getStoredConsent } from './infrastructure/consent/consentManager';
import {
  beforeBreadcrumbScrubber,
  beforeSendScrubber
} from './infrastructure/sentry/piiScrubber';

if (import.meta.env.VITE_ENV != 'local' && import.meta.env.VITE_ENV != 'dev') {
  Sentry.init({
    dsn: 'https://22ba781c247c0e440ec1b0ae0ba63fee@o4511586306490368.ingest.us.sentry.io/4511586312585216',
    // setting sendDefaultPii to false to prevent default PII collection in production
    sendDefaultPii: false,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      })
    ],
    release: 'd1tech-widget@1.0.0',
    environment: import.meta.env.VITE_ENV,
    beforeSend(event) {
      return beforeSendScrubber(event);
    },
    beforeBreadcrumb(breadcrumb) {
      return beforeBreadcrumbScrubber(breadcrumb);
    },
    // Tracing disabled unless performanceDiagnostics consent is granted
    tracesSampler() {
      const consent = getStoredConsent();
      return consent?.categories?.performanceDiagnostics ? 0.1 : 0;
    },
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Replay rates 0 by default, started dynamically upon consent
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0
  });
}
